import { render, staticRenderFns } from "./unionpay-withdrawal.vue?vue&type=template&id=34cdb33e&scoped=true&"
import script from "./unionpay-withdrawal.vue?vue&type=script&lang=js&"
export * from "./unionpay-withdrawal.vue?vue&type=script&lang=js&"
import style0 from "./unionpay-withdrawal.vue?vue&type=style&index=0&id=34cdb33e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cdb33e",
  null
  
)

export default component.exports